/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import {
  showingUpcomingEvents,
  showingPastEvents,
  isPrivate
} from '../../../modules/profile/getters';

import UpcomingEvents from './upcoming';
import PastEvents from './past';
import PrivateEvents from '../private-events/index';

type Props = {
  data: ProfileQuery,
  showingUpcomingEvents: boolean,
  showingPastEvents: boolean,
  currentUser: Object
};

const withStore: Function = connect(
  (state) => ({
    showingUpcomingEvents: showingUpcomingEvents(state),
    showingPastEvents: showingPastEvents(state)
  })
);

const Events: Function = (props: Props): ?React$Element<*> => {
  const { data: { profile }, currentUser } = props;
  const userOwnsProfile = currentUser && currentUser.id === profile.id;

  switch (true) {
    case (isPrivate(profile) && !userOwnsProfile):
      return <PrivateEvents />;
    case props.showingUpcomingEvents:
      return <UpcomingEvents {...props} />;
    case props.showingPastEvents:
      return <PastEvents {...props} />;
  }
};

export default withStore(Events);



// WEBPACK FOOTER //
// ./src/components/profile/events/index.js